const signupForm = document.getElementById("wc_register_user");

if( signupForm ) {
    let ajaxUrl = ajax_callback_data.ajax_url;
    let signupPage = ajax_callback_data.signup_page;
    let loginPage = ajax_callback_data.login_page;

    document.getElementById('reg_email').addEventListener('input', function(event) {
        // set button disabled on email typing
        document.getElementById('email-field').value = 'fail';
        let regEmail = event.target.value;

        if( regEmail.length > 0 ) {

            if( validateEmail(regEmail) ) {
                // Send AJAX request
                var formData = {
                    action: "register_check_email",
                    email: regEmail,
                };

                let submitButton = document.querySelector('.register_btn');

                jQuery.ajax({
                    url: ajaxUrl,
                    type: "POST",
                    data: formData,
                    success: function (response) {
                        if( response.success ) {
                            submitButton.disabled = false;
                            document.querySelectorAll('.errorreg_email').forEach(element => {
                                element.remove();
                            });
                            document.getElementById('email-field').value = 'success';

                        } else {
                            submitButton.disabled = true;
                            document.querySelectorAll('.errorreg_email').forEach(element => {
                                element.remove();
                            });
                            afrigar_message_element_input_validate('reg_email', 'error errorreg_email', response.data);
                        }
                    },
                    error: function () {
                        window.location.href = signupPage;
                    },
                });

            } else {
                let submitButton = document.querySelector('.register_btn');
                submitButton.disabled = !this.checked;

                document.querySelectorAll('.errorreg_email').forEach(element => {
                    element.remove();
                });
                afrigar_message_element_input_validate('reg_email', 'error errorreg_email', 'Please enter valid email');

            }
        }
    });


    signupForm.addEventListener("submit", function (event) {
        event.preventDefault();

        formValid = true;

        // Show loading indicator
        afrigar_loading('flex');

        // Get form fields
        var fname = document.getElementById("reg_userfname").value.trim();
        var lname = document.getElementById("reg_userlname").value.trim();
        var nationalID = document.getElementById("reg_national_id").value.trim();
        var email = document.getElementById("reg_email").value.trim();
        var phone = document.getElementById("reg_phone").value.trim();
        var phoneCode = document.getElementById("reg_phone_code").value.trim();
        var password = document.getElementById("reg_password").value.trim();
        // var address = document.getElementById("reg_address").value.trim();
        // var suburb = document.getElementById("reg_suburb").value.trim();
        // var postcode = document.getElementById("reg_postcode").value.trim();
        // var state = document.getElementById("reg_state").value.trim();
        var country = document.getElementById("reg_country").value.trim();
        // var stateType = document.getElementById("reg_state_type").value.trim();
        // var stateText = document.getElementById("reg_state_text").value.trim();

        var productId = document.getElementById("product-id").value.trim();

        // Helper function to check if a field is empty
        function isFieldEmpty(field, fieldId, fieldName) {
            // Get the input element
            let fieldInput = document.getElementById(fieldId);
            
            // Remove any existing error message
            let existingError = fieldInput.nextElementSibling;
            if (existingError && existingError.classList.contains("error")) {
                existingError.remove();
            }

            // Check if the field is empty
            if (field === "" || field.length<1) {
                // Create a new error message span
                let fieldMessage = fieldName + " is required";
                let fieldError = document.createElement("span");
                errorClass = 'error error' +fieldId;
                fieldError.className = errorClass; // Add the error class
                fieldError.textContent = fieldMessage; // Set the text content

                // Insert the span after the selected element
                fieldInput.parentNode.insertBefore(
                    fieldError,
                    fieldInput.nextSibling
                );

                formValid = false;
            }
        }

        // Perform validation checks
        isFieldEmpty(fname, "reg_userfname", "First name");
        isFieldEmpty(lname, "reg_userlname", "Last name");
        isFieldEmpty(nationalID, "reg_national_id", "National ID");
        isFieldEmpty(email, "reg_email", "Email address");
        isFieldEmpty(phone, "reg_phone", "Phone number");
        // isFieldEmpty(phoneCode, "reg_phone_code", "Phone number");
        isFieldEmpty(password, "reg_password", "Password");
        // isFieldEmpty(address, 'reg_address', 'Address');
        // isFieldEmpty(suburb, 'reg_suburb', 'Suburb/City');
        // isFieldEmpty(state, "reg_state", "State");
        isFieldEmpty(country, "reg_country", "Country");

        // Example of using isNewsletterChecked function in validation
        isNewsletterChecked("newsletter"); // Pass the ID of the newsletter checkbox

        // Function to validate the newsletter checkbox
        function isNewsletterChecked(checkboxId) {
            // Get the checkbox element
            let newsletterCheckbox = document.getElementById(checkboxId);

            // Remove any existing error message
            let existingError = document.querySelector(".agree-tc .error");
            if (existingError) {
                existingError.remove();
            }

            // Check if the checkbox is not checked
            if (!newsletterCheckbox.checked) { 
                if(document.getElementById('checkbox-warning')) {
                    document.getElementById('checkbox-warning').style.display = 'block';
                }

            formValid = false; // Mark the form as invalid
            } else {
                if(document.getElementById('checkbox-warning')) {
                    document.getElementById('checkbox-warning').style.display = 'none';
                }
            }
        }

        // If form is not valid, prevent submission
        if (!formValid) {
            afrigar_loading('none');
            let newsletterCheckbox = document.getElementById("newsletter");
            if (newsletterCheckbox.checked) { 
                window.scrollTo({
                    top: 0,
                    behavior: "smooth", // Smooth scrolling
                });
            } else {
                document.getElementById('reg_country').scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return;
        }

        if(phone.length > 15) {
            let existingError = document.querySelector(".error");
            if (existingError) {
                existingError.remove();
            }
            formValid = false;
            afrigar_message_element_input_validate('reg-phone-field', 'error error-message', 'Maximum allowed 15 characters');
            document.getElementById('reg_email').scrollIntoView({ behavior: 'smooth', block: 'center' });
            afrigar_loading('none');
            return;
        }
        
        // Send AJAX request
        var formData = {
            action: "register_customer_user",
            fname: fname,
            lname: lname,
            nationalID: nationalID,
            email: email,
            phone: phone,
            phoneCode: phoneCode,
            password: password,
            // address: address,
            // suburb: suburb,
            // postcode: postcode,
            // state: state,
            country: country,
            // stateType: stateType,
            // stateText: stateText,
            productId: productId,
        };

        jQuery.ajax({
            url: ajaxUrl, // WordPress provides this global variable for AJAX requests
            type: "POST",
            data: formData,
            success: function (response) {

                const signupValue = "loginMessage";
                const RegisterEmail = email;
                const RegisterPass = password;
                document.cookie = `member_login=${encodeURIComponent(RegisterEmail)}; path=/; SameSite=Strict;`;
                document.cookie = `member_pass=${encodeURIComponent(RegisterPass)}; path=/; SameSite=Strict;`;
                document.cookie = `signupValue=${encodeURIComponent(signupValue)}; path=/; SameSite=Strict;`;
                
                if (response.success) {
                    window.location.href = response.data;
                    // var successMessage = document.querySelector(
                    //     ".signup-success-message"
                    // );
                    // if (successMessage) {
                    //     successMessage.style.display = "flex";
                    // }

                    // window.scrollTo({
                    //     top: 0,
                    //     behavior: "smooth",
                    // });

                    // Optionally, reset the form
                    // document.getElementById("wc_register_user").reset();

                    // setTimeout(function() {
                    // }, 1800);

                } else {
                    if( response.data == 'email-exists' ) {
                        document.querySelectorAll('.errorreg_email').forEach(element => {
                            element.remove();
                        });
                        afrigar_message_element_input_validate('reg_email', 'error errorreg_email', 'Email already exists');

                        window.scrollTo({
                            top: 0,
                            behavior: "smooth", // Smooth scrolling
                        });
                    } else {
                        
                    }
                    afrigar_loading('none');
                }
            },
            error: function () {
                var errorMessage = document.querySelector(".signup-error-message");
                if (errorMessage) {
                    errorMessage.style.display = "flex";
                }

                window.scrollTo({
                    top: 0,
                    behavior: "smooth", // Smooth scrolling
                });

                // Hide loading indicator after success or error
                afrigar_loading('none');
            },
        });
    });
}